import type { LiveLinkState } from 'src/pages/Settings/memberships/components/live-link';
import {
  type LiveLinkLookup,
  useLiveLinkState,
} from 'src/pages/Settings/memberships/hooks/use-live-link-state';
import { useSegmentBaseUrl } from 'src/pages/Settings/memberships/hooks/use-segment-base-url';

/** Not live until the page has a slug, i.e. before its first save. */
export const useLandingPageLiveLink = ({
  partnerId,
  brandId,
  slug,
  configLookup,
}: {
  partnerId: number | null;
  brandId: string | undefined;
  slug: string;
  configLookup: LiveLinkLookup;
}): LiveLinkState => {
  const baseUrl = useSegmentBaseUrl(partnerId, brandId);
  const url = baseUrl.url && slug ? `${baseUrl.url}/${slug}` : undefined;

  return useLiveLinkState(url, baseUrl, configLookup);
};
